
import { computed } from '@nuxtjs/composition-api';
import type { CheckoutDelivery, CheckoutTotal } from '~/type/Checkout';
import type { NewOrder } from '~/type/NewOrder';
import TSBonusCount from '~/components/ts-components/TSBonusCount/TSBonusCount.vue';
import { useUserStore } from '~/store/user';
const __sfc_main = {};
__sfc_main.props = {
  order: {
    key: "order",
    required: true,
    type: null
  },
  delivery: {
    key: "delivery",
    required: true,
    type: null
  },
  total: {
    key: "total",
    required: true,
    type: null
  },
  color: {
    key: "color",
    required: false,
    type: String,
    default: 'yellow'
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const userStore = useUserStore();
  const isUser = computed(() => userStore.isUser);
  const totalPrice = computed(() => {
    return props.total.price.total - (props.order.summary.bonusSpent || 0) + (props.delivery?.price || 0);
  });
  return {
    isUser,
    totalPrice
  };
};
__sfc_main.components = Object.assign({
  TSBonusCount
}, __sfc_main.components);
export default __sfc_main;
